export var TracingSubject;
(function (TracingSubject) {
    TracingSubject["NonAdminInlineNotification"] = "NON-ADMIN-INLINE-NOTIFICATION";
    TracingSubject["StartTrialButton"] = "START-TRIAL-BUTTON";
    TracingSubject["SuspensionBar"] = "TRACING-SUSPENSION-BAR";
    TracingSubject["ApproveStartMetricsTrialButton"] = "tracing-metrics-approve";
})(TracingSubject || (TracingSubject = {}));
export var TracingSuspensionStates;
(function (TracingSuspensionStates) {
    TracingSuspensionStates["NotSuspended"] = "NOT_SUSPENDED";
    TracingSuspensionStates["MonthlySpansQuotaExceeded"] = "MONTHLY_SPANS_QUOTA_EXCEEDED";
    TracingSuspensionStates["DailyIndexingThresholdExceeded"] = "DAILY_INDEXING_THRESHOLD_EXCEEDED";
})(TracingSuspensionStates || (TracingSuspensionStates = {}));
export var TracingProductActivationState;
(function (TracingProductActivationState) {
    TracingProductActivationState[TracingProductActivationState["NotActivated"] = 0] = "NotActivated";
    TracingProductActivationState[TracingProductActivationState["PendingTrial"] = 1] = "PendingTrial";
    TracingProductActivationState[TracingProductActivationState["ActivatedNotInUse"] = 2] = "ActivatedNotInUse";
    TracingProductActivationState[TracingProductActivationState["ActivatedInUse"] = 3] = "ActivatedInUse";
})(TracingProductActivationState || (TracingProductActivationState = {}));
export var TracingAccountCardState;
(function (TracingAccountCardState) {
    TracingAccountCardState["NotActivated"] = "NOT_ACTIVATED";
    TracingAccountCardState["Trial"] = "TRIAL";
    TracingAccountCardState["Free"] = "FREE";
    TracingAccountCardState["Pro"] = "PRO";
})(TracingAccountCardState || (TracingAccountCardState = {}));
export var TracingServiceErrorCode;
(function (TracingServiceErrorCode) {
    TracingServiceErrorCode["TracingNotActivated"] = "tracing/TRACING_NOT_ACTIVATED";
})(TracingServiceErrorCode || (TracingServiceErrorCode = {}));
export const MAX_TRACING_SAMPLING_RULES_AMOUNT = 10;
export var OtelFieldCategory;
(function (OtelFieldCategory) {
    OtelFieldCategory["Service"] = "Service";
    OtelFieldCategory["HTTP"] = "HTTP";
    OtelFieldCategory["Span"] = "Span";
    OtelFieldCategory["Trace"] = "Trace";
})(OtelFieldCategory || (OtelFieldCategory = {}));
//# sourceMappingURL=tracing.enum.js.map